import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'Actions/router';
import SelectIndicatorsInput from 'Components/selectIndicatorsInput';
import { makeIndicatorWithId } from 'Selectors/indicatorWithId';
import * as iconStyles from '../../styles/icons.css';
import * as styles from './selectIndicatorsBundle.css';

class SelectIndicatorsBundle extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false || props.childrenSelected,
    };

    this.toggleChildren = this.toggleChildren.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.checked || nextProps.childrenSelected) {
      this.setState({ visible: true });
    }
  }

  toggleChildren() {
    this.setState((prevState) => ({ visible: !prevState.visible }));
  }

  render() {
    const { id, label, checked, children, onClick } = this.props;
    const { visible } = this.state;

    return (
      <li className={styles.li} key={id}>
        <span>
          <input
            className={styles.input}
            checked={checked}
            id={id}
            type="checkbox"
            onChange={() => onClick(!checked)}
          />
          <label className={styles.label} htmlFor={id}>{label}</label>
          <button className={styles.toggle} onClick={this.toggleChildren}>
            <i
              className={this.state.visible ?
                iconStyles.iconMinus :
                iconStyles.iconPlus}
            />
          </button>
        </span>
        {visible && (
          <ul className={styles.children}>
            {children.map((child) => (
              <SelectIndicatorsInput id={child} key={child} />
            ))}
          </ul>
        )}
      </li>
    );
  }
}

SelectIndicatorsBundle.defaultProps = {
  checked: false,
  childrenSelected: false,
};

SelectIndicatorsBundle.propTypes = {
  id: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.arrayOf(PropTypes.number).isRequired,
  childrenSelected: PropTypes.bool,
};

const mapStateToProps = (state, props) => {
  const selected = state.router.indicators || [];
  const indicator = makeIndicatorWithId()(state, props);
  return {
    ...indicator,
    childrenSelected: !!indicator.children
      .filter((child) => selected.includes(`${child}`)).length,
  };
};

// @TODO move this to it's own file...
const dispatchAction = (child, status) => (dispatch, getState) => {
  const { router: { indicators = [] } } = getState();

  const childInQuery = `${child}` === indicators ||
    (Array.isArray(indicators) && -1 < indicators.indexOf(`${child}`));

  if (status !== childInQuery) {
    dispatch(push({ indicators: child }));
  }
};

const mapDispatchToProps = (dispatch) => ({
  onClick: (children) => (status) => children.forEach(
    (child) => dispatch(dispatchAction(child, status))
  ),
});

const mergeProps = (stateProps, { onClick }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onClick: onClick(stateProps.children),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(SelectIndicatorsBundle);

// Testing exports
export {
  SelectIndicatorsBundle,
  mapStateToProps,
  dispatchAction,
  mapDispatchToProps,
  mergeProps,
};



// WEBPACK FOOTER //
// ./app/components/selectIndicatorsBundle/index.js